<template>
    <ul class="full-width-edit-material" v-loading="loading">
        <li>
            <div class="input-label">
                <span tkey="中文名稱">{{i18n.tkey("lang_cn_name")}}</span>
            </div>

            <div>
                <el-input
                        v-model="productName"
                        placeholder=""
                        clearable
                        show-word-limit
                        maxlength="100"
                />
            </div>
        </li>

        <li>
            <div class="input-label">
                <span tkey="英文名稱">{{i18n.tkey("lang_en_name")}}</span>
            </div>

            <div>
                <el-input
                        v-model="productNameCN"
                        placeholder=""
                        clearable
                        show-word-limit
                        maxlength="100"
                />
            </div>
        </li>

        <li>
            <div class="input-label">
                <span tkey="運費">{{i18n.tkey("lang_d_cost")}}</span>
            </div>

            <div>
                <el-input
                        type="number"
                        v-model="cost"
                        placeholder=""
                        clearable
                        min="0"
                />
            </div>
        </li>

        <li class="region-editor-part">
            <span tkey="地區設置">{{i18n.tkey("lang_region_setting")}}</span>
            <br>
            <transportRegionSettingEditor ref="regionDom" v-model="regionSettingList" />
        </li>

        <li style="text-align: center">
            <el-button type="primary" @click="insertClick" v-if="null == obj" tkey="提交">{{i18n.tkey("lang_submit")}}</el-button>
            <el-button type="primary" @click="updateClick" v-if="null != obj" tkey="保存">{{i18n.tkey("lang_save")}}</el-button>
        </li>
    </ul>
</template>

<script setup>
    import {getCurrentInstance, inject, onMounted, ref, toRef} from "vue";
    import myUtil from "@/util/util"
    import transportRegionSettingEditor from "@/components/shopopee/material/transportRegionSettingEditor"
    import {useUserinfo} from "@/stores/userinfo";
    import eshopopeeApi from "@/request/eshopopeeApi";

    const { proxy } = getCurrentInstance()

    const i18n = inject("i18n")

    const userInfoRef = toRef(useUserinfo())

    const props = defineProps(['obj'])
    const emits = defineEmits(['uploadSuccess', "editSuccess"])

    const productName = ref("")
    const productNameCN = ref("")
    const cost = ref(0)
    const regionSettingList = ref([])

    const loading = ref(false)

    const { getShopCompanyObj } = inject('shopControlFunc', { getShopCompanyObj: () => { return {} } })

    const shopCompany = ref({})

    const regionDom = ref(null)

    function insertClick() {
        if (myUtil.isEmpty(productName.value) || myUtil.isEmpty(productName.value)){
            myUtil.alertWarning(i18n.tkey("lang_enter_complete"))
            return
        }

        if (myUtil.isEmpty(cost.value)){
            myUtil.alertWarning(i18n.tkey("lang_enter_complete"))
            return
        }

        submitData()
    }

    function updateClick() {
        if (myUtil.isEmpty(productName.value) || myUtil.isEmpty(productName.value)){
            myUtil.alertWarning(i18n.tkey("lang_enter_complete"))
            return
        }

        if (myUtil.isEmpty(cost.value)){
            myUtil.alertWarning(i18n.tkey("lang_enter_complete"))
            return
        }

        saveData()
    }

    function submitData() {
        loading.value = true

        const request = eshopopeeApi.insertDelivery
        const params = request.getParams()

        params.deliveryCompanyCode = shopCompany.value.acccompanycode
        params.PTD = productName.value
        params.PTD2 = productNameCN.value
        params.Cost = cost.value
        params.settingList = JSON.stringify(regionSettingList.value)

        request.send(params, (res) => {
            loading.value = false
            myUtil.alertSuccess(i18n.tkey("lang_save_success"))

            productName.value = ""
            productNameCN.value = ""
            cost.value = 0

            emits("editSuccess")
        })
    }

    function saveData() {
        loading.value = true

        const request = eshopopeeApi.updateDelivery
        const params = request.getParams()

        const dataList = regionSettingList.value.concat(regionDom.value.getDelList())

        params.deliveryCompanyCode = shopCompany.value.acccompanycode
        params.PTD = productName.value
        params.PTD2 = productNameCN.value
        params.Cost = cost.value
        params.productID = props.obj.ProductID
        params.settingList = JSON.stringify(dataList)

        request.send(params, (res) => {
            loading.value = false
            if (res.code == 200){
                myUtil.alertSuccess(i18n.tkey("lang_save_success"))
                emits("editSuccess")
            }else{
                myUtil.alertError(i18n.tkey("lang_request_error"))
            }

        })
    }

    onMounted(() => {
        shopCompany.value = getShopCompanyObj()

        if (null != props.obj){
            productName.value = props.obj.ProductName
            productNameCN.value = props.obj.ProductNameCN
            cost.value = props.obj.Cost

            if (null != props.obj.data){
                regionSettingList.value = props.obj.data
            }else{
                regionSettingList.value = []
            }

        }
    })
</script>

<style scoped>
    .full-width-edit-material {
        width: 100%;
        list-style: none;
        padding-left: 0;
        text-align: left;
    }

    .full-width-edit-material li {
        margin-bottom: 20px;
    }

    .input-label {
        margin-bottom: 5px;
        font-weight: 600;
        font-size: 12px;
    }

    .region-editor-part {
        border-radius: 5px;
        box-sizing: border-box;
        border: 1px #E4E7ED solid;
        padding: 20px;
    }
</style>